module.exports = "<div class=\"calendar-container\">\n  <calendar-component\n    class=\"{{$ctrl.format}}\"\n    options=\"$ctrl.options\"\n    on-click=\"$ctrl.clicked($event)\"\n    before-show-day=\"$ctrl.onDayRender($event)\"\n    on-hover-in=\"$ctrl.hoverIn($event)\"\n    on-hover-out=\"$ctrl.hoverOut($event)\">\n  </calendar-component>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInline/calendarInline.html
// module id = 1470
// module chunks = 0